'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingTrustModal = exports.mapStateToProps = exports.BillingTrustModalUnwrapped = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _decorator = require('helpers/decorator');

var _device = require('redux/modules/device');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingTrustModalUnwrapped = exports.BillingTrustModalUnwrapped = function BillingTrustModalUnwrapped(_ref) {
  var isMobile = _ref.isMobile,
      onModalClose = _ref.onModalClose;
  return _react2.default.createElement(
    'section',
    { className: 'checkout__modal' },
    _react2.default.createElement(
      'header',
      { className: 'text--center' },
      _react2.default.createElement(
        'h2',
        { className: 'mb-- delta text--bold' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'checkout.billing-trust-modal.header',
          defaultMessage: 'Why we ask for your billing info'
        })
      )
    ),
    _react2.default.createElement(
      'p',
      { className: 'mb+' },
      _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: 'checkout.billing-trust-modal.copy-paragraph-1',
        defaultMessage: '<strong>Your trial is completely free</strong>, but our <a href=\'https://help.classpass.com/hc/en-us/articles/207942743-What-is-the-class-cancellation-policy\' target=\'_blank\'>class cancellation policy</a> still applies. If you can\u2019t make a class that you\u2019ve booked, make sure to cancel at least 12 hours beforehand to avoid a fee. Otherwise, for most classes, it\u2019s $15 to late cancel and $20 if you miss the class without canceling.'
      })
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'checkout.billing-trust-modal.copy-paragraph-2',
        defaultMessage: 'After your free trial, you\u2019ll be auto-enrolled in our most popular plan. You can cancel your auto-enrollment at any point during your trial. Once on a monthly plan, you can change or cancel your membership at any time.'
      })
    ),
    _react2.default.createElement(
      'button',
      {
        className: (0, _classnames2.default)('bt bt--primary bt--outline bt--lg', {
          'bt--width-lg': !isMobile,
          'bt--width-full': isMobile
        }),
        type: 'submit',
        onClick: onModalClose
      },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'checkout.billing-trust-modal.cta',
        defaultMessage: 'Got it'
      })
    )
  );
};

BillingTrustModalUnwrapped.propTypes = {
  isMobile: _propTypes2.default.bool.isRequired,
  onModalClose: _propTypes2.default.func.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isMobile: (0, _device.selectIsMobile)(state)
  };
};

var BillingTrustModal = exports.BillingTrustModal = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps), (0, _Modal2.default)({ headerClass: 'modal--720' }))(BillingTrustModalUnwrapped);